// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"tg_a bie_b bie_bj","HomeBaseBanner__hint":"tg_b bie_vh","HomeBaseBanner__link":"tg_c"};